import React, { Component, forwardRef } from 'react';
import { Redirect } from 'react-router-dom';
import MaterialTable from 'material-table';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import Loader from '../../../Loader.js';
import Rodal from 'rodal';
import Paper from '@material-ui/core/Paper';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { LocalizationTheme } from '../../../../utils/utils.js';
import { GeTypeMapping, DisplayMessage } from '../../../../services/helpers.js';
import CircularProgress from '@material-ui/core/CircularProgress';
import { sortTableNumbers, sortTableStringsNotCaseSensitive } from '../../../../utils/tableSorting.js';
import appFetch from '../../../../api/appFetch.js';
import { PlanningTeamsUrl, PlanningTeamsWithIdUrl } from '../../../../constants/apiUrls.js';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

export default class TeamsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataGrid: [],
            fetchingData: true,
            showDelete: false,
            deletedItem: 0,
            accessibleMoboOutlets: [],
            editedTeamId: "",
            editedTeam: "",
            showEditTeam: false,
            requestInProgress: false,
            redirect: null,
        };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.refreshGrid) {
            this.getData();
        }

        this.setState({ redirect: null });
    }

    componentWillMount() {
        this.getData();
    }

    getData = () => {
        this.setState({ fetchingData: true });
        let initialData = {};
        var resources = this.props.resources;
        initialData.columns = [
            { 
                title: resources["OutletName"],
                field: 'outletName',
                options: { filter: true, sort: true },
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.outletName, b.outletName) 
            },
            { 
                title: resources["Description"],
                field: 'description',
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.description, b.description) 
            },
            { 
                title: resources["Type"],
                field: 'type',
                options: { filter: true, sort: true },
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.type, b.type) 
            },
            { 
                title: resources["CountMembers"],
                field: 'countMembers',
                options: { filter: true, sort: true },
                customSort: (a, b) => sortTableNumbers(a.countMembers, b.countMembers) 
            },
        ];

        var actions = [
            {
                icon: (rowData) => <Edit />,
                tooltip: resources["Edit"],
                onClick: (event, rowData) => { this.setState({ redirect: `teams/${rowData.id}`, editedTeamId: rowData.id }) }
            },
            {
                icon: () => <DeleteOutline />,
                tooltip: resources["Delete"],
                onClick: (event, rowData) => this.handleShowDelete(rowData.id)
            }
        ];

        initialData.actions = actions;

        appFetch({
            url: PlanningTeamsUrl(),
            onSuccess: (data) => {
                const currentRows = [];

                data.sort((el1, el2) => el1.id - el2.id).forEach(function (item) {
                    currentRows.push({
                        id: item.id,
                        type: resources[GeTypeMapping(item.type)],
                        outletName: item.outletName,
                        description: item.description,
                        countMembers: item.countMembers,
                        outletId: item.outletId
                    });
                });

                initialData.data = currentRows;

                this.setState({
                    dataGrid: initialData,
                    fetchingData: false
                });
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ fetchingData: false });
            }
        })
    }

    handleCloseDelete = () => {
        this.setState({ showDelete: false, deletedItem: "" });
    }

    handleEditTeam = (itemId, showEditTeamdialog) => {
        if (showEditTeamdialog === false) { this.getData(); }
        this.setState({ showEditTeam: showEditTeamdialog, editedTeamId: itemId });
    }

    handleShowDelete = (itemId) => {
        this.setState({ showDelete: true, deletedItem: itemId });
    }

    handleDeleteTeam = () => {
        const {resources} = this.props;
        if (this.state.deletedItem > 0) {
            this.setState({ requestInProgress: true });
            const url = PlanningTeamsWithIdUrl(this.state.deletedItem);

            appFetch({
                url: url,
                method: 'DELETE',
                onSuccess: () => {
                    DisplayMessage(resources["TeamWasDeleted"], "success");
                    this.setState({ showDelete: false, deletedItem: "" });
                    this.getData();
                },
                onError: (data) => {
                    for (let i = 0; i < data.errors.length; i++) {
                        DisplayMessage(data.errors[i], "error");
                    }
                    this.setState({ showDelete: false, deletedItem: "" });
                },
                onFinalize: () => {
                    this.setState({ requestInProgress: false });
                }
            })
        }
    }

    handleAddNewTeam = () => {
        this.setState({ redirect: `teams/new`, editedTeamId: "" });
    }

    render() {
        let resources = this.props.resources;
        const { redirect, editedTeamId, dataGrid, fetchingData } = this.state;
        if (redirect) {
            return <Redirect to={{
                pathname: redirect,
                state: { editedTeamId: editedTeamId, teams: dataGrid.data, refreshGrid: true }
            }} />
        }

        return (
            <div>
                <div className="position-relative py-4">
                    <h3>{resources["PlanningTeams"]}</h3>
                    <div className={"offcentered-loader " + (fetchingData ? 'fadeIn' : 'fadeOut')}><CircularProgress /></div>
                    <div className={"mt-4 " + (fetchingData ? 'fadeOut' : 'fadeIn')}>
                        <div className="float-right mt-3">
                            <div className="float-right mb-3" >
                                <Button id="addNew" onClick={this.handleAddNewTeam} color="primary" variant="contained" >
                                    <i className="fas fa-plus mr-2" title={resources["AddNewTeamTitle"]} />
                                    {resources["AddNewTeam"]}
                                </Button>
                            </div>
                        </div>

                        <div style={{ clear: "both", }}></div>
                        <Paper elevation={3} className="p-3 mt-3">
                            <MuiThemeProvider theme={LocalizationTheme()}>
                                <MaterialTable
                                    icons={tableIcons}
                                    title={""}
                                    localization={{
                                        header: { actions: resources["Actions"] },
                                        body: {
                                            emptyDataSourceMessage: resources["NoRecordsToBeDisplayed"],
                                            deleteTooltip: resources["DeleteTooltip"],
                                            editTooltip: resources["EditTooltip"],
                                        },
                                        toolbar: {
                                            searchPlaceholder: resources["Search"],
                                            searchTooltip: resources["Search"]
                                        },
                                        pagination: {
                                            firstTooltip: resources["FirstTooltip"],
                                            lastTooltip: resources["LastTooltip"],

                                            previousTooltip: resources["PreviousTooltip"],
                                            nextTooltip: resources["NextTooltip"],

                                            labelRowsPerPage: resources["LabelRowsPerPage"],
                                            labelRowsSelect: resources["LabelRowsSelect"],
                                        }
                                    }}
                                    data={this.state.dataGrid.data}
                                    columns={this.state.dataGrid.columns}
                                    actions={dataGrid.actions}
                                    options={{ emptyRowsWhenPaging: false, pageSize: 10, pageSizeOptions: [10, 15, 20] }}
                                />
                            </MuiThemeProvider>
                        </Paper >
                    </div>
                    <div className={"loader-overlap position-absolute " + (this.state.fetchingData ? 'fadeIn' : 'fadeOut')}><div className="container"><Loader /></div></div>

                    <Rodal visible={this.state.showDelete} onClose={this.handleCloseDelete} className="rodal" customStyles={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
                    }}>
                        <div className="modal-body" style={{ marginTop: "20px", display: "flex", alignItems: "center" }}>{resources["AreYouSureYouWantToDeleteTeam"]}</div>
                        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                            <button id="btnCancelDelete" className="btn btn-secondary" style={{ backgroundColor: "white", color: "#53B3EA", borderColor: "#53B3EA" }} onClick={this.handleCloseDelete} disabled={this.state.requestInProgress}>{resources["Cancel"]}</button>
                            <button className="btn btn-primary" id="btnDelete" style={{ backgroundColor: "#53B3EA", color: "white", borderColor: "#53B3EA" }} onClick={this.handleDeleteTeam} disabled={this.state.requestInProgress}>{resources["Yes"]}</button>
                        </div>
                        <span className="rodal-close"></span>
                    </Rodal>
                </div>
            </div >
        )
    };
}